/**
 * $firebase.user 向け。modular User には compat のインスタンスメソッドが無い。
 * FormatEdit 等の巨大 SFC を分解せず、facade 側で modular 関数へ橋渡しする。
 */
import {
  sendEmailVerification,
  updateEmail,
  updatePassword,
  updateProfile,
  type User
} from '@/infra/firebase/auth'

export function withCompatAuthUserMethods<T extends User | null>(user: T): T {
  if (!user) return user

  return new Proxy(user, {
    get(target, prop, receiver) {
      if (prop === 'sendEmailVerification') {
        return (actionCodeSettings?: unknown) =>
          sendEmailVerification(target, actionCodeSettings as never)
      }
      if (prop === 'updateEmail') {
        return (email: string) => updateEmail(target, email)
      }
      if (prop === 'updatePassword') {
        return (password: string) => updatePassword(target, password)
      }
      if (prop === 'updateProfile') {
        return (profile: {
          displayName?: string | null
          photoURL?: string | null
        }) => updateProfile(target, profile)
      }
      const value = Reflect.get(target, prop, receiver)
      if (typeof value === 'function') {
        return value.bind(target)
      }
      return value
    }
  }) as T
}
